// extracted by mini-css-extract-plugin
export default {"headTabInfo":"TimingTargeting_headTabInfo__yG7hz","actionTimeButtons":"TimingTargeting_actionTimeButtons__nREHA","timesInfoLabel":"TimingTargeting_timesInfoLabel__k3e7i"};